import React, { Component } from 'react';
import $ from 'jquery';
import axios from 'axios';
import qs from 'qs';

export default class Pending extends Component {

  getpending() {
      axios.defaults.xsrfCookieName = 'csrftoken'
      axios.defaults.xsrfHeaderName = 'X-CSRFToken'

      axios.post('/api/pendingcount', qs.stringify({
        "address": window.address,
      })).then(function (response) {
        if (response.data.excess > 0) {
          $(".pending-transaction").html(response.data.excess);
        } else {
          $(".pending-transaction").html("0")
        }
      });
  }

  render() {

    const data = this.props.data;

    this.getpending();

    return (
      <div class="row">
          <div class="col-lg-12 col-md-12">
              <div class="card-box">
                  <h2 class="header-title m-t-0 m-b-30">{data.transactionPending}</h2>
                  <h5>{data.numberofPending}:

                          <span class="badge badge-success pending-transaction pull-right"></span>

                  </h5>

              </div>
          </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/dashboard/functions/pending.js